import React from 'react';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import LibroReclamacionesData from '../../Components/Admin/LibroReclamacionesData/LibroReclamacionesData';

export default function LibroReclamacionesAdmin() {
    return (
        <div className="containerGrid">
            <Header />

            <section className="containerSection">
                <HeaderDash />
                <div className="container">
                    <LibroReclamacionesData />
                </div>
            </section>
        </div>
    );
}
